import { useAppDispatch, useAppSelector } from "../hooks";
import { checkPrivacyAndStartMeasurement, cancel } from "../features/measurement/measurementSlice";
import { currentSubscription } from "../networkQuality";
import React, { useEffect } from "react";
import DownUpPing from "../components/speedtest/DownUpPing";
import TariffInfo from "../components/layout/tariffInfo/TariffInfo";
import VpnSticky from "../components/layout/vpnSticky/VpnSticky";
import Prepare from "../components/speedtest/Prepare";
import ModemView from "../components/speedtest/Modem";
import styled from "@emotion/styled";
import HeadWithTags from "../components/elements/HeadWithTags";
import { stopSentryReports } from "../features/sentryReports/sentryReportsSlice";
import { hideNboTeaser } from "../features/nextBestOffer/nextBestOfferSlice";
import { Phase } from "../features/measurement/types";
import { selectPrepareResult } from "../features/measurement/utils";

const SpeedtestContainer = styled.div([
  props => props.theme.typography.regular16,
  props => props.theme.colors.foreground.secondary,
  {
    textAlign: "center",
    display: "inline-block",
    backgroundColor: "transparent",
    width: "100%",
    height: "100%",
    flex: "1",
    alignSelf: "stretch",
  },
]);

interface SpeedtestProps { }

const SpeedtestComponent: React.FC<SpeedtestProps> = ({ }) => {
  const consentState = useAppSelector(state => state.consent);
  const state = useAppSelector(state => state.measurement);
  const dispatch = useAppDispatch();
  const prepareResult = selectPrepareResult(state);

  useEffect(() => {
    dispatch(hideNboTeaser());

    if (consentState.accepted) {
      dispatch(checkPrivacyAndStartMeasurement());
      return function cleanup() {
        dispatch(cancel(currentSubscription.subscription)).then(() => {
          dispatch(stopSentryReports());
        });
      }
    }
  }, [consentState.accepted]);

  function selectComponent(): JSX.Element {
    switch (state.kind) {
      case Phase.NotStarted:
      case Phase.Aborting:
        return <div></div>;

      case Phase.Preparing:
        return <Prepare />;

      case Phase.Benchmarking:
      case Phase.Downloading:
      case Phase.Uploading:
      case Phase.Pinging:
      case Phase.Completing:
      case Phase.ModemResolving:
      case Phase.CompletingNoModem:
      case Phase.FinishedNoModem:
        return <DownUpPing />;

      case Phase.ModemExecuting:
      case Phase.CompletingWithModem:
      case Phase.FinishedWithModem:
        return <ModemView />;
    }
  }

  function tariffInfo() {
    const bookedDownloadSpeed = prepareResult?.init.modem?.bookedDownloadSpeedMax;
    const bookedUploadSpeed = prepareResult?.init.modem?.bookedUploadSpeedMax;
    if (bookedDownloadSpeed && bookedUploadSpeed) {
      return (
        <TariffInfo
          bookedDownloadSpeed={bookedDownloadSpeed}
          bookedUploadSpeed={bookedUploadSpeed}
        />
      );
    } else {
      return <></>;
    }
  }

  return (
    <>
      <HeadWithTags name="speedtest" />
      {prepareResult?.init.connection.isVpnActive == true && <VpnSticky />}
      <SpeedtestContainer>
        {tariffInfo()}
        {selectComponent()}
      </SpeedtestContainer>
    </>
  );
}

export default SpeedtestComponent;
